import { useParams } from 'react-router-dom';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useGetInspectionByShareTokenSuspense } from '../../../../../services/api/generated/client';
import { inspectionRefreshed, tokenRefreshed, } from '../../../../../actions/inspectionDetail';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import { localise, templateReplace } from '../../../../../services/lang/lang';
import { Alert } from '../../../../modules/Alert/Alert';
import { InspectionDetailShareProvider } from './InspectionDetailShareProvider';
import InspectionDetailContent from '../InspectionDetailContent';
const InspectionDetailShareWrapper = () => {
    const dispatch = useDispatch();
    const { token } = useParams();
    dispatch(tokenRefreshed(token));
    const { data: response } = useGetInspectionByShareTokenSuspense(token, {
        axios: { headers: { 'api-version': 'v3' } },
    });
    if (!response) {
        return null;
    }
    const inspection = unwrapModel(response);
    if (!inspection) {
        return (React.createElement(Alert, { "data-testid": "inspection_detail_wrapper__alert", status: "error", icon: true, title: localise('SOMETHING_WRONG') }, templateReplace(localise('RESOURCE_NOT_FOUND'), {
            noun: localise('INSPECTION'),
        })));
    }
    dispatch(inspectionRefreshed(inspection));
    return (React.createElement(InspectionDetailShareProvider, { value: { token } },
        React.createElement(InspectionDetailContent, { inspection: inspection, isShare: true, hasPermissionToEdit: false })));
};
export default InspectionDetailShareWrapper;
